import React from 'react';
import { useTrainingTranslation } from '../hooks/useTrainingTranslation';

const CustomTrainingCTA = () => {
  const { getTranslation } = useTrainingTranslation();
  const translation = getTranslation();

  return (
    <div className="text-center bg-gradient-to-r from-blue-50 to-cyan-50 rounded-2xl py-8 px-6 border border-blue-100">
      <p className="text-lg text-gray-700 font-medium">
        {translation.customTraining.text}{' '}
        <button
          onClick={() => document.getElementById('training-request')?.scrollIntoView({ behavior: 'smooth' })}
          className="text-blue-600 font-semibold hover:text-blue-700 transition-colors underline decoration-blue-300 underline-offset-4"
        >
          {translation.customTraining.buttonText}
        </button>
      </p>
    </div>
  );
};

export default CustomTrainingCTA;
